// /src/components/ProtectedRoute.js
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import useAuth from '../hooks/useAuth';
import { useSelector } from 'react-redux';

// Routes here require the caller's role to be in the allowed list.
// Any route NOT listed is allowed for any authenticated user.
const ROUTE_ROLE_RULES = {
  '/user-access': ['Admin', 'Manager'],
  '/admin-logs': ['Admin', 'Manager'],
  '/user-permissions': ['Admin', 'Manager'],
  // /reports-analytics: all authenticated users can open the route;
  // Access Denied for User is handled inside the page.
  '/firebase-test': ['Admin'],
};

const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  const authUser = useSelector((state) => state.auth.user);
  const location = useLocation();

  if (loading) {
    // Show a loading spinner or message while checking authentication
    return <div>Loading...</div>;
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Fail closed: while role hasn't loaded yet, treat as no-role (not Admin/Manager).
  const role = authUser?.role || null;

  const allowedRoles = ROUTE_ROLE_RULES[location.pathname];
  if (allowedRoles && !allowedRoles.includes(role)) {
    return <Navigate to="/dashboard" replace />;
  }

  // Render the children if authenticated and role checks pass
  return children;
};

export default ProtectedRoute;
